import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
    selector: 'app-right-drawer',
    templateUrl: './right-drawer.component.html',
    styleUrls: ['./right-drawer.component.scss']
})
export class RightDrawerComponent {
    @Input() open = false;
    @Output() close = new EventEmitter<void>();

    onBackdropClick() {
        this.close.emit();
    }
}
